export default "__VITE_ASSET__CtSJkejn__"